import { SelectionCard } from 'src/app/shared/components/payments';

import { Selection, type Props as SelectionProps } from '../../components/Selection';
import { useSunriseHoldoutExperiment } from '../hooks/useSunriseHoldoutExperiment';

export function NoSelection({
	label,
	message,
	checked,
	onSelect,
	children,
	...selectionProps
}: SelectionProps): JSX.Element {
	const { variant: sunriseHoldoutExperimentVariant } = useSunriseHoldoutExperiment();

	if (sunriseHoldoutExperimentVariant === 'variant_3') {
		return <SelectionCard type="text" label={label} description={message} selected={checked} onClick={onSelect} />;
	}

	return <Selection label={label} message={message} checked={checked} onSelect={onSelect} {...selectionProps} />;
}
